import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const CaseStudies = lazy(() => import('../pages/case-studies/page'));
const CaseStudyDetail = lazy(() => import('../pages/case-studies/detail/page'));
const GardenBloomPrivacy = lazy(() => import('../pages/gardenbloomprivacy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/case-studies',
    element: <CaseStudies />,
  },
  {
    path: '/case-studies/:slug',
    element: <CaseStudyDetail />,
  },
  {
    path: '/gardenbloomprivacy',
    element: <GardenBloomPrivacy />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
